export default __webpack_public_path__ + "dac8c46408d765a85ff6a81bdc5954cd.png";